import { Route, Routes } from 'react-router-dom';
import {
  LogisticsOrderFormPage,
  LogisticsOrdersListPage,
  LogisticsProvidersPage,
} from '@/modules/logistics/pages';
import { logisticsPaths } from '@/modules/logistics/paths';

export function LogisticsModule() {
  return (
    <Routes>
      <Route index element={<LogisticsOrdersListPage />} />
      <Route path={logisticsPaths.orderNew} element={<LogisticsOrderFormPage />} />
      <Route path={logisticsPaths.providers} element={<LogisticsProvidersPage />} />
      <Route path={logisticsPaths.orderDetail} element={<LogisticsOrderFormPage />} />
    </Routes>
  );
}
